import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/employees/$id/')({
  component: EmployeeIndex,
});

function EmployeeIndex() {
  const { id } = Route.useParams();

  // Redirect to jobs tab by default
  return <Navigate to="/admin/employees/$id/jobs" params={{ id }} replace />;
}
